import config from '@/Config';

export function isProductionEnvironment() {
    return config.environment === environments.production;
}

export function isLocalEnvironment() {
    return config.environment === environments.local;
}

export const environments = {
    dev: 'Dev',
    loadTest: 'LoadTest',
    local: 'Local',
    production: 'Production',
    stage: 'Stage',
    test: 'Test',
    uiTests: 'UiTests',
    testA: 'test-a',
    testB: 'test-b',
    stageA: 'stage-a',
    stageB: 'stage-b',
};